import Vue from 'vue'
import VueResource from 'vue-resource'
import Router from 'vue-router'

import routes from '@/router/routes.js'
import { getOidcClient } from '@/services/oidc_client.js'

Vue.use(Router)
Vue.use(VueResource)

const envPrefix = process.env.ENV_URLS && process.env.ENV_URLS !== 'production' ? `[${process.env.ENV_URLS}] ` : ''

const router = new Router({
	routes,
	mode: 'history'
})

// Routes that don't require authentication
const publicRoutes = ['login', 'Complete TPauth OIDC Callback']

router.beforeEach(async (to, from, next) => {
	// Skip auth check for public routes
	if (publicRoutes.includes(to.name)) {
		next()
		return
	}

	// eslint-disable-next-line no-undef
	const userCookie = $cookies.get('user')

	if (!userCookie) {
		// No cookie - redirect to login
		router.replace({
			name: 'login',
			query: {
				next_url: to.fullPath
			}
		}).catch((error) => {
			console.log(error.message)
		})
		return
	}

	// First load of the app (not internal navigation) - verify OIDC token is still valid
	const isFirstLoad = !from.name
	if (isFirstLoad) {
		// Check if session was invalidated (e.g., invalid_grant error before refresh)
		const sessionInvalidated = sessionStorage.getItem('oidc_session_invalidated')
		if (sessionInvalidated) {
			const ts = new Date().toISOString()
			console.log(`[${ts}] OIDC: Session was invalidated before page reload, redirecting to login`)
			sessionStorage.removeItem('oidc_session_invalidated')
			// eslint-disable-next-line no-undef
			$cookies.remove('user')
			router.replace({
				name: 'login',
				query: {
					next_url: to.fullPath
				}
			}).catch((error) => {
				console.log(error.message)
			})
			return
		}

		try {
			const oidcClient = getOidcClient()
			const user = await oidcClient.getUser()

			if (!user || user.expired) {
				// Token is expired - clear cookie and redirect to login
				const ts = new Date().toISOString()
				console.log(`[${ts}] OIDC: Token expired on app load, redirecting to login`)
				// eslint-disable-next-line no-undef
				$cookies.remove('user')
				router.replace({
					name: 'login',
					query: {
						next_url: to.fullPath
					}
				}).catch((error) => {
					console.log(error.message)
				})
				return
			}
		} catch (error) {
			const ts = new Date().toISOString()
			console.error(`[${ts}] OIDC: Error checking token on app load`, error)
			// On error, clear cookie and redirect to login to be safe
			// eslint-disable-next-line no-undef
			$cookies.remove('user')
			router.replace({
				name: 'login',
				query: {
					next_url: to.fullPath
				}
			}).catch((err) => {
				console.log(err.message)
			})
			return
		}
	}

	// Store previous route for navigation history
	if (from.name) {
		window.localStorage.setItem('prev_route', JSON.stringify({
			fullPath: from.fullPath,
			name: from.name,
			params: from.params,
			query: from.query
		}))
	}

	next()
})

router.beforeResolve(async (to, from, next) => {
	next()
	if (to.name && to.path !== '/maestro/jobs') {
		document.title = `${envPrefix}${to.meta.label} - Gravity`
	} else {
		document.title = `${envPrefix}Gravity`
	}
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js